import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { Part } from "../../parts/models/Part";
import { ComponentType } from "../models/ComponentType";

export class ComponentTypesRepository {
	private axios: Axios;

	constructor(token?: string) {
		this.axios = axiosInstance;

		this.getComponentTypes = this.getComponentTypes.bind(this);
		this.getComponentTypeById = this.getComponentTypeById.bind(this);
		this.createComponentType = this.createComponentType.bind(this);
		this.updateComponentType = this.updateComponentType.bind(this);
		this.updatePartByComponentType = this.updatePartByComponentType.bind(this);
		this.deleteComponentType = this.deleteComponentType.bind(this);
	}

	async getComponentTypes() {
		try {
			const componentTypes = await this.axios.get("/ComponentType/");

			return {
				ok: true,
				componentTypes: componentTypes.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getComponentTypeById(componentTypeId: number | null) {
		try {
			const componentType = await this.axios.get(
				`/ComponentType/${componentTypeId}`,
			);
			return {
				ok: true,
				componentType: componentType.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}

	async createComponentType({
		componentTypeId,
		componentTypeName,
		rootTypeId,
		isRepair,
		isTracked,
	}: ComponentType) {
		try {
			await this.axios.post("/ComponentType/", {
				componentTypeId,
				rootTypeId: rootTypeId == 1 ? 3 : rootTypeId,
				componentTypeName,
				isRepair,
				isTracked,
			});

			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async updateComponentType(
		componentTypeId: number | null,
		componentTypeData: ComponentType,
	) {
		try {
			await this.axios.patch(
				`/ComponentType/${componentTypeId}`,
				componentTypeData,
			);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async updatePartByComponentType(componentTypeId: number | null, ids: any) {
		let idArray: Array<Number> = [];

		ids.forEach((ct: Part) => idArray.push(ct.partId));

		try {
			const resp = await this.axios.patch(
				`/ComponentType/${componentTypeId}/parts`,
				null,
				{ params: { ids: idArray.toString() } },
			);

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async deleteComponentType(componentTypeId: number | null) {
		try {
			await this.axios.delete(`/ComponentType/`, {
				params: { componentTypeId },
			});
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const {
	getComponentTypes,
	getComponentTypeById,
	createComponentType,
	updateComponentType,
	updatePartByComponentType,
	deleteComponentType,
} = new ComponentTypesRepository();
